var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ERRORS } from '../consts/errors';
import { mapCamelKeysToSnakeKeysRecursively, mapSnakeKeysToCamelKeysRecursively, toCamelCase, } from './case-conversion';
import { isObjEqual } from './object';
var ACTION_PAYLOAD_REGEX = /^data\.template\.actions\.[0-9]+\.payload$/;
var ACTION_QUERY_PARAMS_REGEX = /^data\.template\.actions\.[0-9]+\.query_params$/;
export var formatLinkApiResponse = function (res) {
    var response = mapSnakeKeysToCamelKeysRecursively(res, {
        checkShouldRecursionStop: function (path) {
            var pathString = path.join('.');
            return (ACTION_PAYLOAD_REGEX.test(pathString) ||
                ACTION_QUERY_PARAMS_REGEX.test(pathString));
        },
    });
    if (response.data)
        return response.data;
    if (response.error && response.error.type === 'INVALID_LINK_TOKEN') {
        return {
            responseType: 'error',
            error: __assign(__assign({}, ERRORS.invalidLinkToken), { code: toCamelCase(response.error.code.toLowerCase()), description: response.error.message }),
        };
    }
    if (response.error && response.error.code === 'TIMED_OUT_WITH_NO_BANK_INFO') {
        return {
            responseType: 'error',
            error: ERRORS.timedOutWithNoBankInfo,
        };
    }
    // Handle 400 errors like used link token
    var error = {
        responseType: 'error',
        error: ERRORS.clientError,
    };
    return error;
};
export function formatRequest(req, linkApiResponse) {
    if (linkApiResponse.responseType === 'next' ||
        linkApiResponse.responseType === 'next_with_error') {
        if (linkApiResponse.template.templateType !== 'form' &&
            linkApiResponse.template.templateType !== 'bank_info')
            return req;
        var isPayloadAnAction = linkApiResponse.template.actions.some(function (action) {
            return isObjEqual('payload' in action ? action.payload : null, req);
        });
        return {
            payload: isPayloadAnAction
                ? req
                : mapCamelKeysToSnakeKeysRecursively(req),
        };
    }
    return req;
}
